/* LeoNoir — geo-aware announcement bar.
   Shows the free-shipping threshold that matches the visitor's country.
   Priority: ?geo=XX test param > storefront country selector (Markets) > IP detection.
   NL keeps the full default message (with delivery promise). */
(function () {
  var THRESHOLDS = {
    BE: 100, LU: 100, DE: 100,
    FR: 125, AT: 125, DK: 125,
    ES: 150, IT: 150, PT: 150, SE: 150, IE: 150, PL: 150, CZ: 150,
    GB: 175,
    CH: 200, NO: 200,
    US: 250, CA: 250,
    AE: 300, SA: 300, QA: 300, KW: 300, BH: 300, OM: 300
  };
  var REST_OF_WORLD = 350;
  var contextCountry = (document.currentScript && document.currentScript.dataset.contextCountry || '').toUpperCase();

  function apply(country) {
    if (!country || country === 'NL') return; // default text is the NL message
    var amount = THRESHOLDS[country] || REST_OF_WORLD;
    document.querySelectorAll('.announcement-bar__message').forEach(function (el) {
      if (el.textContent.indexOf('€75') === -1) return; // only touch the shipping message
      el.textContent = 'Gratis verzending vanaf €' + amount + '  |  Wereldwijde verzending 🚚';
    });
  }

  // 1. test override: ?geo=BE (not cached, wins over everything)
  var forced = new URLSearchParams(location.search).get('geo');
  if (forced) { apply(forced.toUpperCase()); return; }

  // 2. explicit storefront country selection (Markets / "View as" preview)
  if (contextCountry && contextCountry !== 'NL') { apply(contextCountry); return; }

  // 3. IP detection via Shopify's own endpoint (cached per session)
  var cached = null;
  try { cached = sessionStorage.getItem('leonoir_geo_country'); } catch (e) {}
  if (cached) { apply(cached); return; }

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
    headers: { Accept: 'application/json' }
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var c =
        (data && data.detected_values && data.detected_values.country &&
          (data.detected_values.country.handle || data.detected_values.country.iso_code)) ||
        null;
      if (c) {
        c = String(c).toUpperCase();
        try { sessionStorage.setItem('leonoir_geo_country', c); } catch (e) {}
        apply(c);
      }
    })
    .catch(function () { /* keep default NL text */ });
})();
